export default __webpack_public_path__ + "1c4330835269c55d9ad8753299a987d0.png";